module.exports = __webpack_public_path__ + "static/images/40369742745cda1c9e33f06fa9d56997.png";